import { html, nothing } from "lit";
import { buildChatEditRewindConfirmMessage } from "../chat/chat-pending-edit.ts";

export type ChatEditRewindConfirmProps = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function renderChatEditRewindConfirm(props: ChatEditRewindConfirmProps) {
  if (!props.open) {
    return nothing;
  }

  return html`
    <div
      class="exec-approval-overlay chat-edit-rewind-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="chat-edit-rewind-title"
      aria-live="polite"
    >
      <div class="exec-approval-card chat-edit-rewind-card">
        <div class="exec-approval-header">
          <div>
            <div id="chat-edit-rewind-title" class="exec-approval-title">Reset from edited message?</div>
            <div class="exec-approval-sub">Same as editing in Cursor — rewind, then send your new text</div>
          </div>
        </div>
        <p class="chat-edit-rewind-body muted">${buildChatEditRewindConfirmMessage()}</p>
        <div class="exec-approval-actions">
          <button type="button" class="btn primary" @click=${props.onConfirm}>Reset &amp; send</button>
          <button type="button" class="btn" @click=${props.onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  `;
}
